import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-119" data-mp="gokqv61p7sl3">
      {visible && <motion.div initial={{
      y: 120,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 120,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3 sm:pb-5" data-id="element-120" data-mp="gnj6gaysltqp">
          <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md animate-shake items-center justify-center gap-2 rounded-2xl border-b-4 border-cta-dark bg-cta px-5 py-4 text-[16px] font-black uppercase tracking-wide text-white shadow-cta motion-reduce:animate-none focus-visible:outline focus-visible:outline-4 focus-visible:outline-gold" data-id="element-121" data-mp="14dn6k8crvbcy">
            <span className="whitespace-nowrap" data-id="element-122" data-mp="269w0z4sv4fzk">Get it now for $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-123" data-mp="1rdoluiwba4r5" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}